/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCombinedPackingRemarkVo
 */
export interface UpdateCombinedPackingRemarkVo {
    /**
     * 合包包装作业备注；传空值或空白字符串表示清空
     * @type {string}
     * @memberof UpdateCombinedPackingRemarkVo
     */
    combinedPackingRemark?: string;
}

/**
 * Check if a given object implements the UpdateCombinedPackingRemarkVo interface.
 */
export function instanceOfUpdateCombinedPackingRemarkVo(value: object): value is UpdateCombinedPackingRemarkVo {
    return true;
}

export function UpdateCombinedPackingRemarkVoFromJSON(json: any): UpdateCombinedPackingRemarkVo {
    return UpdateCombinedPackingRemarkVoFromJSONTyped(json, false);
}

export function UpdateCombinedPackingRemarkVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCombinedPackingRemarkVo {
    if (json == null) {
        return json;
    }
    return {
        
        'combinedPackingRemark': json['combinedPackingRemark'] == null ? undefined : json['combinedPackingRemark'],
    };
}

export function UpdateCombinedPackingRemarkVoToJSON(json: any): UpdateCombinedPackingRemarkVo {
    return UpdateCombinedPackingRemarkVoToJSONTyped(json, false);
}

export function UpdateCombinedPackingRemarkVoToJSONTyped(value?: UpdateCombinedPackingRemarkVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'combinedPackingRemark': value['combinedPackingRemark'],
    };
}

